module.exports = __webpack_public_path__ + "static/media/background-business.0722160a.jpg";